import PersonaEditor from '../../../components/PersonaEditor';
import { ensureConfig } from '../../../components/personaConfig';
import type { PersonaConfigData } from '../../../components/personaConfig';

export interface DigitalHumanPanelProps {
  /** 形象配置（原始 JSON）。 */
  avatarConfig: Record<string, unknown> | null;
  /** 声音配置（原始 JSON）。 */
  voiceConfig: Record<string, unknown> | null;
  /** 保存形象配置。 */
  onSaveAvatar: (data: object) => void;
  /** 保存声音配置。 */
  onSaveVoice: (data: object) => void;
}

/** 数字人维度面板：形象（Avatar）与声音（Voice）配置编辑。 */
export default function DigitalHumanPanel({ avatarConfig, voiceConfig, onSaveAvatar, onSaveVoice }: DigitalHumanPanelProps) {
  return (
    <div>
      <h3>数字人配置</h3>
      <div className="flex flex-col gap-4">
        <div>
          <h4 className="mb-2">形象配置 (Avatar)</h4>
          <PersonaEditor
            value={ensureConfig((avatarConfig || {}) as Partial<PersonaConfigData>)}
            onChange={(data) => onSaveAvatar(data)}
          />
        </div>
        <div>
          <h4 className="mb-2">声音配置 (Voice)</h4>
          <PersonaEditor
            value={ensureConfig((voiceConfig || {}) as Partial<PersonaConfigData>)}
            onChange={(data) => onSaveVoice(data)}
          />
        </div>
      </div>
    </div>
  );
}
